import { render, staticRenderFns } from "./SwitchWithConfirm.vue?vue&type=template&id=87797e6c&scoped=true"
import script from "./SwitchWithConfirm.vue?vue&type=script&lang=ts"
export * from "./SwitchWithConfirm.vue?vue&type=script&lang=ts"
import style0 from "./SwitchWithConfirm.vue?vue&type=style&index=0&id=87797e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87797e6c",
  null
  
)

export default component.exports